/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import {
  forwardRef,
  memo,
  Ref,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import GoogleMapReact from 'google-map-react-concurrent';
import { GoogleMapWrapper, MarkerWrapper } from './styled';
import { useSelector } from 'react-redux';
import { selectDetailProject } from '@containers/Home/selectors';

interface Props {
  lat: number;
  lng: number;
}
const Marker = memo((props: Props) => {
  return (
    <MarkerWrapper {...props}>
      <img src="/static/img/icon-3.svg" alt="" />
    </MarkerWrapper>
  );
});

export type Type_RefFuncGoogleMap = {
  onPanToMarker: () => void;
};

const Map = forwardRef((_, ref: Ref<Type_RefFuncGoogleMap>) => {
  const mapRef = useRef<any>(null!);
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  const detailProject = useSelector(selectDetailProject);

  const onPanToMarker = useCallback(() => {
    mapRef.current?.panTo({
      lat: detailProject?.location?.latitude || detailProject?.lat,
      lng: detailProject?.location?.longitude || detailProject?.lng,
    });
  }, [detailProject]);

  useEffect(() => {
    if (isMapLoaded && detailProject?.id) onPanToMarker();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMapLoaded, detailProject]);

  useImperativeHandle(
    ref,
    () => ({
      onPanToMarker: () => onPanToMarker(),
    }),
    [onPanToMarker],
  );

  return (
    <GoogleMapWrapper>
      <GoogleMapReact
        bootstrapURLKeys={{
          key:
            process.env.REACT_APP_GOOGLE_KEY ||
            'AIzaSyAcwcJSrJ4_PqEIJoQCtC5RP988Eka0YE8',
          libraries: ['places', 'draw'],
        }}
        draggable
        defaultCenter={[21.0278, 105.8342]}
        defaultZoom={18}
        options={() => ({
          minZoom: 2,
          panControl: false,
          mapTypeControl: false,
          scrollwheel: true,
          streetViewControl: false,
          disableDefaultUI: true,
        })}
        scrollWheelZoom="center"
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map }) => {
          mapRef.current = map;
          setIsMapLoaded(true);
        }}
      >
        {(!!detailProject?.location?.latitude || !!detailProject?.lat) && (
          <Marker
            lat={detailProject?.location?.latitude || detailProject?.lat}
            lng={detailProject?.location?.longitude || detailProject?.lng}
          />
        )}
      </GoogleMapReact>
    </GoogleMapWrapper>
  );
});

export default memo(Map);
